// extracted by mini-css-extract-plugin
export default {"border":"l3inO4P7IdMSHh3eYFYg-style-border","filters":"Ke7VFnOGnr9VQ3Hpkj54-style-filters"};